// language=GraphQL
export const ALL_ONLINE_PAYMENTS_QUERY = `query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  onlinePayments: onlinePayments {
    id
    transactionId
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    transactionStatus
    submittedToBackoffice
    statusPayload
  }
}`

// language=GraphQL
export const SINGLE_ONLINE_PAYMENT_QUERY = `query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  onlinePayment: onlinePayment(id: $id) {
    id
    transactionId
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    transactionStatus
    submittedToBackoffice
    statusPayload
  }
}`

// language=GraphQL
export const CREATE_ONLINE_PAYMENT_MUTATION = `
  mutation Mutation($input: CreateOnlinePaymentInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    onlinePayment: createOnlinePayment(input: $input) {
      id
      transactionId
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      transactionStatus
      submittedToBackoffice
      statusPayload
    }
  }`

// language=GraphQL
export const UPDATE_ONLINE_PAYMENT_MUTATION = `
  mutation Mutation($input: UpdateOnlinePaymentInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    onlinePayment: updateOnlinePayment(input: $input) {
      id
      transactionId
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      transactionStatus
      submittedToBackoffice
      statusPayload
    }
  }`

// language=GraphQL
export const DELETE_ONLINE_PAYMENT_MUTATION = `
  mutation Mutation($input: DeleteOnlinePaymentInput) {
    deleteOnlinePayment(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ONLINE_PAYMENT_MUTATION = `
  mutation Mutation($input: DeleteOnlinePaymentInput) {
    forceDeleteOnlinePayment(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ONLINE_PAYMENTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withBookings: Boolean = false) {
  groupedDependents: onlinePaymentDependents(id: $id) {
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived    }
  }
}`
